import React from 'react';

const About = () => {
  return (
    <>
      <div
        className='bg-no-repeat bg-center bg-cover w-screen relative py-40 '
        style={{ backgroundImage: 'url(images/bg-about.jpg)' }}
      >
        <p className='px-6 text-4xl font-normal text-left md:font-medium md:text-6xl text-white md:px-12 lg:px-40 2xl:px-96 w-5/6 leading-snug'>
          Since 1950, we have participated in nearly every major public lands
          victory.
        </p>
      </div>
      <p className='text-3xl px-6 py-12 md:text-5xl text-left md:p-12 lg:px-40 2xl:px-96 text-black'>
        Make it stand out.
      </p>
      <div className='flex flex-col px-6 md:flex-wrap md:flex-row md:px-12 lg:px-40 2xl:px-96 text-black '>
        <p className='pb-12 text-left md:w-2/6 md:pb-24 md:pr-8 text-base font-light'>
          <span className='block font-medium text-xl pb-8'>Dream it.</span>
          It all begins with an idea. Maybe you want to launch a business. Maybe
          you want to turn a hobby into something more. Or maybe you have a
          creative project to share with the world. Whatever it is, the way you
          tell your story online can make all the difference.
        </p>
        <p className='pb-12 text-left md:w-2/6 md:pb-24 md:pr-8 text-base font-light'>
          <span className='block font-medium text-xl pb-8'>Build it.</span>
          It all begins with an idea. Maybe you want to launch a business. Maybe
          you want to turn a hobby into something more. Or maybe you have a
          creative project to share with the world. Whatever it is, the way you
          tell your story online can make all the difference.
        </p>
        <p className=' pb-12 text-left md:w-2/6 md:pb-24 md:pr-8 text-base font-light'>
          <span className='block font-medium text-xl pb-8'>Grow it.</span>
          It all begins with an idea. Maybe you want to launch a business. Maybe
          you want to turn a hobby into something more. Or maybe you have a
          creative project to share with the world. Whatever it is, the way you
          tell your story online can make all the difference.
        </p>
        <p className='pb-12 text-left md:w-2/6 md:pb-24 md:pr-8 text-base font-light'>
          <span className='block font-medium text-xl pb-8'>Sell it.</span>
          It all begins with an idea. Maybe you want to launch a business. Maybe
          you want to turn a hobby into something more. Or maybe you have a
          creative project to share with the world. Whatever it is, the way you
          tell your story online can make all the difference.
        </p>
        <p className='pb-12 text-left md:w-2/6 md:pb-24 md:pr-8 text-base font-light'>
          <span className='block font-medium text-xl pb-8'>Style it.</span>
          It all begins with an idea. Maybe you want to launch a business. Maybe
          you want to turn a hobby into something more. Or maybe you have a
          creative project to share with the world. Whatever it is, the way you
          tell your story online can make all the difference.
        </p>
        <p className='pb-12 text-left md:w-2/6 md:pb-24 md:pr-8 text-base font-light'>
          <span className='block font-medium text-xl pb-8'>Share it.</span>
          It all begins with an idea. Maybe you want to launch a business. Maybe
          you want to turn a hobby into something more. Or maybe you have a
          creative project to share with the world. Whatever it is, the way you
          tell your story online can make all the difference.
        </p>
      </div>
    </>
  );
};

export default About;
